import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';

export default class CompaniesMetricScoresNew {

  constructor() {}

  render() {

  	filterTypeahead('.metrics-typeahead', 'metrics', '/metrics/search?', 550, 'cause');

	  // On typeahead select, fill associated field
	  $('.metrics-typeahead').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
	    ev.preventDefault();
      $(this).closest('.input-group').find('input[type=\'hidden\']').val(suggestion.value);
      $(this).typeahead('val', suggestion.name_short);
      $(this).blur();
	  });

    // Number display
    let decimals = $('.number-display').attr('data-scale');
    if (typeof decimals === 'undefined') {decimals = 2;}
    $('.number-display').number( true, decimals );

    // Update hidden field on data entry
    $('.number-display').on("change paste keyup", function() {
      let val = $(this).val();
      let hiddenInput = $(this).closest('.form-group').find('input[type=\'hidden\']');
      hiddenInput.val(val);
    });

    // On review assignment
    $('.review-assignment-field').off().on('change', function() {
      let val = $(this).val();
      if (val === "") {
        $('#review_assignment_destroy').val('true')
      } else {
        $('#review_assignment_destroy').val('false')
      }
    })

  }

}